import React, { useState, useEffect } from 'react';
import { Table, Button, Spin } from 'antd';
import { getApproverDashboard } from '../../redux/slice';
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import { data } from 'autoprefixer';
import LocalStorage from '../../../../utilities/localStorage.js';
import moment from 'moment';



const DashboardTable = ({ columns, search,monthFilter  }) => {
  const dispatch = useDispatch();
  const { approverDashboard, approverpagination, loading } = useSelector(
    (state) => state.projectList,
  );
  const user_details = LocalStorage.getItem('bbs_user');
  const [currpage, setCurrPage] = useState(1);
  const [isLoading, setIsLoading] = useState(loading);

  const handlePageChange = (type) => {
    if (type === 'next' && currpage < approverpagination?.totalPages) {
      setCurrPage(currpage + 1);
    } else if (type === 'prev' && currpage > 1) {
      setCurrPage(currpage - 1);
    }
  };

  useEffect(() => {
    if (user_details?.user?.id) {
      const payload = {
        userId: user_details?.user?.id,
        page: currpage,
        search,
        month_array: JSON.stringify(monthFilter || []),
      };
      dispatch(getApproverDashboard(payload));
    }
  }, [dispatch, user_details?.user?.id, currpage, search, monthFilter]);

  useEffect(() => {
    if (loading) {
      // Show the loader for at least 1 second
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(timer); // Cleanup
    } else {
      setIsLoading(false);
    }
  }, [loading]);

  console.log('pagination totapages: ', approverpagination?.totalPages);
  const dataSource = approverDashboard || [];
  // Calculate total pages based on totalItems and pageSize
  //const totalPages = Math.ceil(pagination.total / pagination.pageSize);

  console.log('datasourcetable: ', dataSource);
  return (
    <div className="dashboard-table-container">
      <div className="table-wrapper">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          loading={{
            spinning: loading, // Spinner controlled by Redux loading state
            indicator: <Spin size="large" />, // Custom large spinner
          }} // Disable default Ant Design pagination
        />
      </div>

      <div className="flex items-center justify-between mt-4 pagination-controls">
        {/* Display Current Page Info */}
        <div className="text-gray-600 page-info">
          Page {currpage} of {approverpagination?.totalPages}
        </div>

        {approverpagination?.totalPages > 1 && (
        <div className="pagination-buttons">
          <Button
            disabled={currpage === 1}
            onClick={() => handlePageChange('prev')}
            style={{
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Previous
          </Button>
          <Button
            disabled={currpage === approverpagination?.totalPages}
            onClick={() => handlePageChange('next')}
            style={{
              marginLeft: '8px',
              backgroundColor: '#FFFFFF',
              color: '#344054',
              borderStyle: 'solid',
              borderRadius: '8px',
              borderColor: '#D0D5DD',
            }}
          >
            Next
          </Button>
        </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTable;

// import React, { useState, useEffect } from 'react';
// import { Table, Button } from 'antd';
// import { getapproverDashboard } from '@features/dashboard/redux/slice';
// import './style.css';
// import { useSelector, useDispatch } from 'react-redux';

// const DashboardTable = ({ dataSource, columns }) => {
//   const dispatch = useDispatch();
//   const { approverDashboard } = useSelector((state) => state.projectList);

//   const [pagination, setPagination] = useState({
//     current: 1, // Fallback if no data available yet
//     pageSize: 7, // Default page size
//     total: 0, // Default total items
//   });

//   useEffect(() => {
//     if (approverDashboard?.paginationInfo?.totalItems) {
//       setPagination((prev) => ({
//         ...prev,
//         total: approverDashboard.paginationInfo.totalItems,
//       }));
//     }
//   }, [approverDashboard]); // Runs when approverDashboard changes

//   // Calculate total pages
//   const totalPages = Math.ceil(pagination.total / pagination.pageSize);

//   // Extract the data array from dataSource
//   const data = dataSource?.data || [];

//   // Handle page change
//   const handlePageChange = (page) => {
//     setPagination((prev) => ({
//       ...prev,
//       current: page,
//     }));

//     // Dispatch new data fetch based on current page and page size
//     dispatch(getapproverDashboard({ currentPage: page, itemsPerPage: pagination.pageSize }));
//   };

//   // Paginate the data array based on current page and page size
//   const paginatedData = data.slice(
//     (pagination.current - 1) * pagination.pageSize,
//     pagination.current * pagination.pageSize
//   );

//   return (
//     <div className="dashboard-table-container">
//       <hr />
//       <div className="table-wrapper">
//         <Table
//           dataSource={paginatedData}
//           columns={columns}
//           pagination={false} // Disable default Ant Design pagination
//         />
//       </div>

//       <div className="flex items-center justify-between mt-4 pagination-controls">
//         <div className="text-gray-600 page-info">
//           Page {pagination.current} of {totalPages}
//         </div>

//         <div className="pagination-buttons">
//           <Button
//             className="btn"
//             disabled={pagination.current === 1}
//             onClick={() => handlePageChange(pagination.current - 1)}
//             style={{
//               backgroundColor: '#FFFFFF',
//               color: '#344054',
//               borderStyle: 'solid',
//               borderRadius: '8px',
//               borderColor: '#D0D5DD',
//             }}
//           >
//             Previous
//           </Button>
//           <Button
//             disabled={pagination.current === totalPages}
//             onClick={() => handlePageChange(pagination.current + 1)}
//             style={{
//               marginLeft: '8px',
//               backgroundColor: '#FFFFFF',
//               color: '#344054',
//               borderStyle: 'solid',
//               borderRadius: '8px',
//               borderColor: '#D0D5DD',
//             }}
//           >
//             Next
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardTable;

// const DashboardTable = ({ columns }) => {
//   const dispatch = useDispatch();
//   const { approverDashboard, pagination } = useSelector((state) => state.projectList);

//   const [currpage, setCurrPage] = useState(1);

//   // Fetch data on page change
//   useEffect(() => {
//     dispatch(getApproverDashboard({ page: currpage }));
//   }, [dispatch, currpage]);

//   const handlePageChange = (type) => {
//     if (type === 'next' && currpage < pagination?.totalPages) {
//       setCurrPage(currpage + 1);
//     } else if (type === 'prev' && currpage > 1) {
//       setCurrPage(currpage - 1);
//     }
//   };

//   // Ensure `dataSource` is updated correctly
//   const dataSource = approverDashboard?.data || [];

//   return (
//     <div className="dashboard-table-container">
//       <Table dataSource={dataSource} columns={columns} pagination={false} />

//       <div className="flex items-center justify-between mt-4 pagination-controls">
//         <div className="page-info">Page {currpage} of {pagination?.totalPages}</div>

//         <div className="pagination-buttons">
//           <Button
//             disabled={currpage === 1}
//             onClick={() => handlePageChange('prev')}
//           >
//             Previous
//           </Button>
//           <Button
//             disabled={currpage === pagination?.totalPages}
//             onClick={() => handlePageChange('next')}
//           >
//             Next
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };
